import {
  ContentSection as ContentSectionClient,
  type ContentSectionProps,
} from './ContentSectionClient';

export function ContentSection(sccProps: ContentSectionProps) {
  return <ContentSectionClient {...sccProps} />;
}
